import React from "react";
import "./AgentDockFox.css";

function AgentDockFox({
  className = "",
  size = "md",
  mood = "awake",
  bump = false,
  walking = false,
}) {
  const sizeClass = size === "lg" ? "agent-dock-fox--lg" : "agent-dock-fox--md";
  const sleep = mood === "sleep";

  return (
    <div
      className={`agent-dock-fox ${sizeClass}${bump ? " agent-dock-fox--bump" : ""}${
        walking ? " agent-dock-fox--walking" : ""
      } ${className}`.trim()}
      aria-hidden="true"
    >
      <svg
        className="agent-dock-fox__svg"
        viewBox="0 0 16 14"
        shapeRendering="crispEdges"
        role="img"
        aria-hidden="true"
      >
        <rect x="3" y="1" width="1" height="1" fill="#E0483E" />
        <rect x="3" y="2" width="2" height="1" fill="#E0483E" />
        <rect x="3" y="3" width="3" height="1" fill="#E0483E" />
        <rect x="12" y="1" width="1" height="1" fill="#E0483E" />
        <rect x="11" y="2" width="2" height="1" fill="#E0483E" />
        <rect x="10" y="3" width="3" height="1" fill="#E0483E" />
        <rect x="3" y="4" width="10" height="6" fill="#E0483E" />
        <rect x="5" y="8" width="6" height="2" fill="#F6E7DA" />
        <rect x="13" y="7" width="1" height="3" fill="#E0483E" />
        <rect x="14" y="5" width="2" height="5" fill="#E0483E" />
        <rect x="14" y="5" width="2" height="1" fill="#F6E7DA" />
        <g className="agent-dock-fox__legs agent-dock-fox__legs--left">
          <rect x="4" y="10" width="1" height="2" fill="#7A2019" />
          <rect x="6" y="10" width="1" height="2" fill="#7A2019" />
        </g>
        <g className="agent-dock-fox__legs agent-dock-fox__legs--right">
          <rect x="9" y="10" width="1" height="2" fill="#7A2019" />
          <rect x="11" y="10" width="1" height="2" fill="#7A2019" />
        </g>
        {!sleep && <rect className="agent-dock-fox__eye" x="4" y="5" width="2" height="2" fill="#1E1E1E" />}
        {!sleep && <rect className="agent-dock-fox__eye" x="9" y="5" width="2" height="2" fill="#1E1E1E" />}
        {sleep && (
          <>
            <rect x="4" y="6" width="2" height="0.45" fill="#7A2019" />
            <rect x="9" y="6" width="2" height="0.45" fill="#7A2019" />
          </>
        )}
        {!sleep && <rect x="7" y="8" width="2" height="1" fill="#1E1E1E" />}
        {sleep && <rect x="7" y="8" width="2" height="0.35" fill="#7A2019" opacity="0.85" />}
      </svg>
    </div>
  );
}

export default AgentDockFox;
